import { forwardRef, type SelectHTMLAttributes } from 'react';

type Option = { value: string; label: string };

type Props = SelectHTMLAttributes<HTMLSelectElement> & {
  options: Option[];
  /** Texto de la opción vacía. Pasa `null` para omitirla. */
  emptyLabel?: string | null;
};

export const Select = forwardRef<HTMLSelectElement, Props>(function Select(
  { options, emptyLabel = '— sin elegir —', className = '', ...props },
  ref,
) {
  return (
    <select
      ref={ref}
      className={`block w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm shadow-sm cursor-pointer focus:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500 ${className}`}
      {...props}
    >
      {emptyLabel !== null && <option value="">{emptyLabel}</option>}
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
});
